export const filterAllAttributesFromCategories = (categories: Array<GQL.ICategory>) => {
    return (categories || []).reduce((data: Array<GQL.IAttribute>, category: GQL.ICategory) => {
        if (category.attributes != undefined) {
            category.attributes.forEach((attribute: GQL.IAttribute) => {
                const exists = data.find(attr => attr.id === attribute.id);
                if (!exists) {
                    data.push(attribute);
                }
            });
        }

        return data;
    }, []);
};



// WEBPACK FOOTER //
// ./src/helpers/Categories/filterAllAttributesFromCategories.ts